const $ = jQuery = require('jquery')

var jcarousel = require('jcarousel')

// Carousel
$('.js-carousel')
    .on('jcarousel:reload jcarousel:create', function ()
    {
        var carousel = $(this),
            width = carousel.innerWidth();

        if (width >= 860) {
            width = width / 5;
        } else if (width >= 600) {
            width = width / 3;
        } else if (width >= 350) {
            width = width / 2;
        }


        carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
    })
    .jcarousel({
        wrap: 'circular'
    })
    .jcarouselAutoscroll({
        interval: 3000,
        target: '+=1',
        autostart: true
    });
